import { useEffect, useState } from "react";
import { fetchCoursesList } from "../../Services/CourseListService";

const useCourses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 9,
    totalCount: 0,
    totalPages: 0,
    orderByLatest: true,
    isPublished: undefined // This controls server-side filtering
  });

  const fetchData = async () => {
    try {
      setLoading(true);

      const data = await fetchCoursesList({
        pageNumber: pagination.currentPage,
        pageSize: pagination.pageSize,
        orderByLatest: pagination.orderByLatest,
        isPublished: pagination.isPublished // Send filter to API
      });

      // Set courses from API response
      // Apply frontend sorting (backend does NOT sort)
const items = Array.isArray(data?.items) ? data.items : [];

const sortedItems = [...items].sort((a, b) => {
  const dateA = new Date(a.createdOn).getTime();
  const dateB = new Date(b.createdOn).getTime();

  return pagination.orderByLatest
    ? dateB - dateA   // Latest first
    : dateA - dateB;  // Oldest first
});

setCourses(sortedItems);

      // Update pagination from API response
      if (data) {
   setPagination(prev => ({
  ...prev,
  totalCount: data.totalCount ?? 0,
  totalPages: data.totalPages ?? 0,
  pageNumber: data.pageNumber ?? prev.currentPage,
  pageSize: data.pageSize ?? prev.pageSize
}));

      }
      console.log("courses ......",data);

      setError(null);
    } catch (err) {
      console.error("Error in useCourses hook:", err);
      setError(err.message || "Failed to load courses");
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data when pagination or filter changes
  useEffect(() => {
    fetchData();
  }, [
    pagination.currentPage,
    pagination.pageSize,
    pagination.orderByLatest,
    pagination.isPublished // Add this dependency
  ]);

  const handlePageChange = (page) => {
    setPagination(prev => ({ 
      ...prev, 
      currentPage: page 
    }));
  };

  const handlePageSizeChange = (size) => {
    setPagination(prev => ({
      ...prev,
      pageSize: Number(size),
      currentPage: 1 // Reset to first page when page size changes
    }));
  };

  const handleSortChange = (orderByLatest) => {
    setPagination(prev => ({
      ...prev,
      orderByLatest: orderByLatest,
      currentPage: 1 // Reset to first page when sort changes
    }));
  };

  const handleFilterChange = (isPublished) => {
    setPagination(prev => ({
      ...prev,
      isPublished: isPublished,
      currentPage: 1 // Reset to first page when filter changes
    }));
  };

  return {
    courses,
    loading,
    error,
    pagination,
    handlePageChange,
    handlePageSizeChange,
    handleSortChange,
    handleFilterChange,
    refetch: fetchData
  };
};

export default useCourses;